export const PREFERENCES = {
  NAVIGATOR: "in2w_navigator",
  TABS: "in2w_tabs",
  INDICATORS: "in2w_indicators",
  UNITS: "in2w_units",
  NETWORK_GROUPS: "in2w_network_groups",
};

// in2w_navigator
// group for navigator to open each views
// [
//   {
//     disabled: boolean,
//     group: NavigatorHelper.GROUP,
//     nav: [ { item: NavigatorHelper.NAV_REPORT, disabled: boolean }, ... ]
//   }, ...
// ]

// in2w_tabs
// units tabs settings
// [ { id: NetworkUnitKpiListing.kpiConstants, disabled: boolean }, ... ]

// in2w_indicators
// indicators for network overview
// [ { id: number, disabled: boolean }, ... ]
// note: id reference to DataHelper.getMetricOptions()

// in2w_units
// custom units for each network / yield set
// {
//   [networkId: string]: number[] // array of unitIds, or
//   [networkId: string]-[yieldSetId: string]: number[] // array of unitIds
//   ...
// }
